function decodeObfuscatedContact(encoded) {
    if (!encoded) return '';

    let normalized = encoded.replace(/-/g, '+').replace(/_/g, '/');
    const pad = normalized.length % 4;

    if (pad) {
        normalized += '='.repeat(4 - pad);
    }

    try {
        return atob(normalized);
    } catch {
        return '';
    }
}

function revealContactLink(link) {
    const encoded = link.dataset.contact;
    const type = link.dataset.contactType;
    const value = decodeObfuscatedContact(encoded);

    if (!value) return;

    if (type === 'email') {
        link.href = `mailto:${value}`;
        link.textContent = value;
        return;
    }

    if (type === 'phone') {
        link.href = `tel:${value.replace(/[\s.\-]/g, '')}`;
        link.textContent = value;
    }
}

export function initObfuscatedContacts(root = document) {
    root.querySelectorAll('.js-obfuscated-contact[data-contact]').forEach(revealContactLink);
}
